// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M19 5.5H22V14H12V15H14V22H8V15H10V12H20V7.5H19V11H2V2H19V5.5ZM10 20H12V17H10V20Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-format-painter-filled')
export default class FormatPainterFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'format-painter-filled',
    }
  }
}
